import { render, staticRenderFns } from "./IDCardInfo.vue?vue&type=template&id=487de06e&scoped=true"
import script from "./IDCardInfo.vue?vue&type=script&lang=js"
export * from "./IDCardInfo.vue?vue&type=script&lang=js"
import style0 from "./IDCardInfo.vue?vue&type=style&index=0&id=487de06e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487de06e",
  null
  
)

export default component.exports